function t(t){return/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t)}export{t as default};
